import { jsx as i, jsxs as v, Fragment as k } from "react/jsx-runtime";
import n, { useState as G, useEffect as L } from "react";
import x, { css as y, styled as R } from "styled-components";
import { u as z } from "../chunks/useForwardRef.7bf5d172.js";
import { R as H, I as O } from "../chunks/index.cff5baaf.js";
import { RangoBadge as W } from "./Badge.js";
import { _ as V, j as $, a as X } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import { R as Z } from "../chunks/index.b09c00db.js";
const q = x.div.withConfig({
  displayName: "Badge",
  componentId: "sc-1c5voan-0"
})(["position:absolute;bottom:var(--spacing-half);left:50%;transform:translateX(-50%);"]), D = x(H).withConfig({
  displayName: "Icon",
  componentId: "sc-1c5voan-1"
})([""]), J = x.span.withConfig({
  displayName: "Label",
  componentId: "sc-1c5voan-2"
})(["", ";", ""], (t) => t.selected ? y(["", " color:var(--selected-label-color);"], $) : y(["", " color:var(--text-label-color);"], V), (t) => !t.selected && y(["&:hover:before{", ";content:'';position:absolute;top:var(--spacing-1x);bottom:var(--spacing-1x);left:calc(-1 * var(--spacing-1x));right:calc(-1 * var(--spacing-1x));border-radius:var(--border-radius-sm);z-index:-1;}"], X)), K = x.div.withConfig({
  displayName: "Container",
  componentId: "sc-1c5voan-3"
})(["display:inline-flex;height:var(--size-6x);align-items:center;gap:var(--spacing-half);flex-shrink:0;box-sizing:border-box;position:relative;cursor:pointer;z-index:0;", ""], (t) => t.selected && y(["", "{color:var(--selected-icon-color);}"], D)), Q = n.forwardRef(({
  index: t = 0,
  selected: a = !1,
  showIcon: I = !1,
  showNotification: g = !1,
  label: T = "",
  icon: B,
  onClick: m,
  onSelected: s,
  ...l
}, d) => {
  const [p, h] = G({
    selected: a,
    showNotification: g
  }), b = z(d);
  L(() => {
    h({
      selected: a,
      showNotification: g
    });
  }, []), L(() => {
    a && s && s(b.current);
  }, [a]);
  const w = (C) => {
    h({
      selected: !0,
      showNotification: !1
    }), s(b.current), m && m(C);
  }, N = () => /* @__PURE__ */ i(k, { children: p.showNotification && !p.selected && /* @__PURE__ */ i(q, { children: /* @__PURE__ */ i(W, {}) }) }), S = () => /* @__PURE__ */ v(k, { children: [
    I && /* @__PURE__ */ i(D, { icon: B, size: O.SM }),
    N(),
    /* @__PURE__ */ i(J, { selected: p.selected, children: T })
  ] });
  return L(() => {
    h({
      selected: a,
      showNotification: g
    });
  }, [a, g]), /* @__PURE__ */ i(K, { selected: p.selected, index: t, ...l, ref: b, onClick: w, children: S() });
});
Q.displayName = "RangoTabItem";
const U = R.div.withConfig({
  displayName: "Container",
  componentId: "sc-1jkgs0y-0"
})(["display:inline-flex;align-items:flex-start;gap:var(--spacing-3x);box-sizing:border-box;position:relative;width:100%;"]), Y = R.div.withConfig({
  displayName: "Line",
  componentId: "sc-1jkgs0y-1"
})(["position:absolute;bottom:4.8px;left:50%;height:var(--border-width-md);width:16px;border-radius:var(--border-radius-circular);background-color:var(--selected-border-color);transition:all 0.3s ease-in-out;"]), ee = R.div.withConfig({
  displayName: "ShowMoreContainer",
  componentId: "sc-1jkgs0y-2"
})(["display:flex;margin-left:calc(var(--spacing-2x) * -1);position:relative;"]), te = R.select.withConfig({
  displayName: "ShowMoreSelect",
  componentId: "sc-1jkgs0y-3"
})(["position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;z-index:2;cursor:pointer;"]), ne = n.forwardRef(({
  children: t,
  onTabChange: a,
  ...I
}, g) => {
  const m = "resize", s = z(g), l = n.useRef(null), [d, p] = n.useState(null), [h, b] = n.useState(n.Children.count(t));
  n.useEffect(() => (A(), window.addEventListener(m, A, !1), () => window.removeEventListener(m, A, !1)), [t]), n.useEffect(() => w(), [d, h, t]);
  const w = () => {
    const e = C().some((r) => +r.getAttribute("index") === d || r.dataset.selected === "true");
    l.current.style.display = e ? "block" : "none";
  }, N = (e) => {
    p(e), a && a(e);
  }, S = (e) => {
    n.Children.forEach(t, (r, o) => {
      o === +e.target.value && (l.current.style.display = "none", p(o), a(o));
    });
  }, C = () => {
    const e = _().length > 0 ? 2 : 0;
    return Array.from(s.current.children).slice(0, s.current.children.length - e);
  }, _ = () => n.Children.toArray(t).slice(h), A = () => {
    if (s.current) {
      let e = 0;
      const r = s.current.offsetWidth, o = C();
      o.forEach((M, E) => {
        E < o.length - 1 && (e += M.getBoundingClientRect().width);
      });
      const c = r - (24 * n.Children.toArray(t).length - 1), u = o.length ? o.length - 1 : n.Children.toArray(t).length - 1, f = Math.floor(c / (e / u)) ?? 0;
      b(f > n.Children.toArray(t).length ? n.Children.toArray(t).length : f);
    }
  }, P = (e) => {
    const r = l.current, o = Number(r.getBoundingClientRect().width / 2).toFixed(2), u = s.current.getBoundingClientRect().left, f = e.width / 2, E = e.x - u + f - Number(o);
    l.current && (l.current.style.display = "block", l.current.style.left = `${E}px`);
  }, F = () => {
    let e = !1, r = [];
    return n.Children.map(t, (o) => {
      e = e || o.props.selected !== void 0, r.push(o.props.index);
    }), n.Children.toArray(t).slice(0, h).map((o) => {
      const c = o.props, u = d !== null ? c.index === d : e ? c.selected : r[0] === c.index;
      return [n.cloneElement(o, {
        ...c,
        onClick: () => N(c.index),
        onSelected: (f) => P(f.getBoundingClientRect()),
        selected: u,
        "data-selected": u
      })];
    });
  }, j = () => /* @__PURE__ */ i(n.Fragment, { children: _().length > 0 && /* @__PURE__ */ v(ee, { children: [
    /* @__PURE__ */ i(Z, { icon: "MoreLine", size: "sm", ariaLabel: "Botão com as tabs restantes" }),
    /* @__PURE__ */ v(te, { onChange: S, value: d ?? void 0, "aria-label": "Tabs", "data-testid": "rango-tab-show-more", "data-rango-component": "rango-tab-show-more", "data-is-rango": !0, children: [
      /* @__PURE__ */ i("option", { hidden: !0, value: "" }),
      _().map((e, r) => /* @__PURE__ */ i("option", { value: e.props.index, children: e.props.label }, r))
    ] })
  ] }) });
  return /* @__PURE__ */ v(U, { ref: s, id: "rango-tab", "data-testid": "rango-tab", "data-rango-component": "rango-tab", "data-is-rango": !0, ...I, children: [
    F(),
    j(),
    /* @__PURE__ */ i(Y, { "data-testid": "rango-tab-line", ref: l })
  ] });
});
ne.displayName = "RangoTab";
export {
  ne as RangoTab,
  Q as RangoTabItem
};
